<script setup lang="ts">
/**
 * The standing chat disclaimer (MAR-148).
 *
 * One line under the composer on every chat surface: Marcus can be wrong, review its work, and
 * here is where to tell us when it was. It is deliberately NOT tied to the empty state and NOT
 * scroll-dependent — the ticket's requirement is that it is always visible.
 *
 * Mounted by the composer's callers rather than by `ChatInput` itself, because `ChatInput`'s `box`
 * variant is a bordered card that clips its children: the legend belongs UNDER the card, not
 * inside it. Three call sites (`chat/ChatPanel.vue` twice, `WordChatPanel.vue` once) is still one
 * component and one copy.
 *
 * Feedback is a plain `mailto:` by decision (Alex, 2026-09-07) — no form, no endpoint, no table.
 *
 * `short`: the web composer's one-line form, which sits between scope and the model on the line under
 * the input (MAR-1057). The Word add-in and plan notices keep the full sentence.
 */
const props = defineProps<{ short?: boolean }>()
const { t } = useI18n()

const FEEDBACK_EMAIL = 'alex@holamarcus.com'
</script>

<template>
  <i18n-t
    :keypath="props.short ? 'chat.disclaimer.textShort' : 'chat.disclaimer.text'"
    tag="p"
    scope="global"
    class="text-center text-[11px] leading-relaxed text-muted-foreground"
    :class="props.short ? 'truncate' : 'px-1 pt-1.5'"
  >
    <template #feedback>
      <a
        :href="`mailto:${FEEDBACK_EMAIL}`"
        class="underline underline-offset-2 hover:text-foreground transition-colors"
      >{{ t(props.short ? 'chat.disclaimer.feedbackShort' : 'chat.disclaimer.feedback') }}</a>
    </template>
  </i18n-t>
</template>
